import React from 'react';
import { Typography } from 'antd';

const { Title, Text, Paragraph } = Typography;

function WorkExperienceItem({ title, company, date }) {
  return (
    <>
      <div className="experience-header">
        <span className="work-title">{title}</span>
        <span className="date">{date}</span>
      </div>
      <span className="company">{company}</span>
    </>
  );
}

export default WorkExperienceItem;